import React from 'react';
import './index.css'
import Img from '../../../assets/images/asian-elderly.png'


function Section1 (){
    return(
        <>
        <div className="BgTop">
            <button>Lorem is</button>

        </div>
        <div className="about">
        <div>
            
        </div>
            <h3>About The DMP</h3>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in </p>
        </div>
        </>

    )
}
export default Section1